import React from "react";
import ChatListItem from "./chat-list-item";
import { useChatUsers } from "../../../../api-hooks/use-chat-users";
import { useSelectedUser } from "../../../../api-hooks/use-selected-user";

const ChatListItems = () => {
  const { users } = useChatUsers(true);
  const { selectedUser, setSelectedUser } = useSelectedUser();

  return (
    <>
      {users?.map((u) => (
        <ChatListItem
          handleUserSelect={() => setSelectedUser(u)}
          key={u.userId}
          user={u}
          isSelected={selectedUser?.userId === u.userId}
        />
      ))}
    </>
  );
};

export default ChatListItems;
